
import Vue from 'vue'
import ProductCartTile from './ProductCartTile.vue'

export default Vue.extend({
  name: 'Payment',
  components: {
    ProductCartTile
  },
  computed: {
    cartProducts() {
      return this.$store.state.cart
    },
    cartTotal() {
      return this.$store.getters.cartTotal
    }
  }
})
